import { ElMessage, ElLoading } from 'element-plus';
import InputPhoneComponent from '@/common/components/InputPhoneComponent';
import { formatterPhone } from '@/common/functions/formatters';
import { mapGetters } from 'vuex';
import UsersApi from '@/frontend/api/user';
import { Plus } from '@element-plus/icons-vue';
export default {
  name: "ProfileInfoPage",
  components: {
    Plus,
    InputPhoneComponent
  },

  data() {
    return {
      User: {
        profile: {},
        imageWithPath: ''
      },
      form: {
        address: ''
      },
      formType: 1,
      showEdit: false
    };
  },

  computed: { ...mapGetters(['user'])
  },
  methods: {
    formatterPhone,

    changeForm(number) {
      if (number === 2) {
        this.form.address = '';
        this.formType = 2;
      } else {
        this.formType = 1;
      }
    },

    handlerSelectPhoto(uploadFile) {
      let rawFile = uploadFile.raw;

      if (rawFile.type !== 'image/jpeg' && rawFile.type !== 'image/png') {
        ElMessage.error('Допустимые фото формата JPEG или PNG');
        return false;
      } else if (rawFile.size / 1024 / 1024 > 1) {
        ElMessage.error('Изображение не может превышать 1MB!');
        return false;
      }

      this.form.photo = uploadFile.raw;
      this.User.imageWithPath = URL.createObjectURL(uploadFile.raw);
      return true;
    },

    handlerSave() {
      let Form = new FormData(),
          loader;
      loader = ElLoading.service({
        lock: false,
        text: 'Загрузка'
      });

      for (let key in this.form) {
        if (key === 'photo') Form.append('uploadImage', this.form[key]);else Form.append(key, this.form[key]);
      }

      UsersApi.update(this.User.id, Form).then(() => {
        window.scroll(0, 0);
        window.location.reload();
      }).catch(this.handlerErrorRequest).finally(() => {
        loader.close();
      });
    },

    handlerErrorRequest(error) {
      if (!error.type || error.type === 'undefined error') {
        ElMessage.error(error.message || 'Непредвиденная ошибка!');
        console.error(error);
        return;
      }

      if (error.type === 'validate' || error.type === 'not found') {
        ElMessage({
          message: Array.isArray(error.message) ? error.message[0] : error.message,
          type: 'warning'
        });
        return;
      }

      ElMessage.error('Отсутствует обработчик ошибки!');
      console.error(error);
    }

  },

  created() {
    UsersApi.get({
      expand: ['profile'].join('')
    }, this.user('id')).then(response => {
      this.User = response;
      this.form.email = response.email || '';
      this.form.name = response.profile.name || '';
      this.form.phone = response.profile.phone || '';
      this.form.description = response.profile.description || '';
      this.form.address = response.profile.address || '';
    }).catch(error => {
      ElMessage.error('Неизвестная ошибка');
      console.error(error);
    });
  }

};